<template>
  <v-app id="app">
    <v-content>
      <v-container fill-height class="pa-0">
        <v-layout>
          <v-flex>
            <router-view />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "error-layout"
}
</script>
